<div class="container-fluid mt-4 mb-5" *ngIf="!isSkeletonLoading">
  <div class="row m-2">
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
  </div>
  <div class="row m-2">
      <ng-container *ngFor="let product of products">
          <div class="col" *ngIf="product.name !== 'Free (Internal)' && (product.metadata['custom'] === 'false' || currentProduct?.id === product.id)">
              <mat-card class="mat-elevation-z8 h-100 p-3">
                  <mat-card-header class="row justify-content-center">
                      <div class="row text-center">
                            <mat-toolbar *ngIf="currentProduct?.id === product.id"
                                class="current-subscription">
                                <p style="width: 100%;">Current Subscription</p>
                            </mat-toolbar>
                      </div>
                      <div class="row text-center pt-2">
                          <div class="col-12">
                              <h2>{{product?.name}}</h2>
                          </div>
                          <div class="col-12">
                              <h3 class="mat-h3">{{product.description}}</h3>
                          </div>
                      </div>
                  </mat-card-header>
                  <hr />
                  <mat-card-content class="row mb-3">
                      <div class="col">
                          <ul *ngFor="let feature of product?.marketing_features">
                                  <li>{{ feature?.name }}</li>
                          </ul>
                      </div>
                  </mat-card-content>
                  <mat-card-actions class="row">
                      <div class="col text-center">
                          <button mat-raised-button
                              *ngIf="currentProduct?.id !== product.id" (click)="createOrUpdateSubscription(product)">Select</button>
                      </div>
                  </mat-card-actions>
              </mat-card>
          </div>
      </ng-container>
  </div>
</div>
<ng-container *ngIf="isSkeletonLoading">
  <my-account-subscriptions-skeleton></my-account-subscriptions-skeleton>
</ng-container>